export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg className={className} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="18" cy="18" r="17" fill="#0A0A0A" />
    <rect x="6.3" y="21.2" width="23.3" height="4.1" fill="#F7F7C9" />
    <rect x="16.4" y="11.2" width="3.2" height="10" fill="#F7F7C9" />
    <line x1="16" y1="21.2" x2="8.9" y2="14.3" stroke="#F7F7C9" strokeWidth="3.2" strokeLinecap="square" />
    <line x1="20" y1="21.2" x2="27.1" y2="14.3" stroke="#F7F7C9" strokeWidth="3.2" strokeLinecap="square" />
  </svg>
);

export const Logo = ({ className = "" }) => (
  <span className={`inline-flex items-center gap-2 ${className}`}>
    <LogoMark className="h-8 w-8" />
    <span className="font-display text-xl font-extrabold tracking-tight">Essenza</span>
  </span>
);
